import React, { Component } from "react";

export default class ErrorPage extends Component {
  render() {
    return (
        <div>Visit this IP address, (< a target="_blank" href='https://47.245.101.153/' > QuickSave or https://47.245.101.153/</a >), we do not have a domain name yet.</div>
    )
  }
}
